import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';


import PhoneNumbers from './NumberCallerQueues';
import EndpointNumbers from './EndpointNumber';
import TimeQueues from './TimesQueues';


import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';

const QueueIdentifyAnswered = (props) => {
  const { queue, socketio } = props;

  const [ answeredCalls, setAnsweredCalls ] = useState({});
  const [ countCalls, setCountCalls ] = useState(0);

  useEffect(() => {
    socketio.on(`${queue}`, async (data) => {
      if(data.event == "AgentConnect") {
        setAnsweredCalls((prevState) => {
          prevState[`${data.uniqueid}`] = { name: data.interface, endpoint: data.membername, phone: data.calleridnum, uniqueid: data.uniqueid };
          return prevState;
        });
        setCountCalls((prevState) => { 
          return prevState + 1;
        });
      }

      if(data.event == "QueueMemberStatus") {
        if (Object.keys(answeredCalls).length > 0 && data.status === '1') {
          setAnsweredCalls((prevState) => {
              Object.keys(answeredCalls).forEach((call) => {
                if(answeredCalls[call].name === data.interface){
                  delete prevState[call];
                }
              })

            return prevState;
          });
          setCountCalls((prevState) => { 
            return prevState - 1;
          });
        }
      }
    });
  }, [answeredCalls, countCalls]);

  return (
    Object.keys(answeredCalls).length > 0 ? Object.keys(answeredCalls).map((uniq) => {
        return (     
          <tr className="is-size-7 has-text-centered" key={ uniq }>
            <PhoneNumbers numberPhone={ answeredCalls[`${uniq}`].phone } />
            <EndpointNumbers endpointNumber={ answeredCalls[`${uniq}`].endpoint } />
            <TimeQueues timex={ 0 } />
          </tr>
        )
      }) : null
  )
}

// QueueIdentifyAnswered.propTypes = {
//   clid: PropTypes.string,
// };

export default QueueIdentifyAnswered;